<script setup lang="ts">
import { onBeforeUnmount, watch } from "vue";
import Button from "./Button.vue";

const props = withDefaults(defineProps<{
  open: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
}>(), {
  title: "确认删除",
  message: "",
  confirmLabel: "删除",
});

const emit = defineEmits<{ cancel: []; confirm: [] }>();

function onKey(event: KeyboardEvent) {
  if (event.key === "Escape") emit("cancel");
}

watch(() => props.open, (open) => {
  if (open) window.addEventListener("keydown", onKey);
  else window.removeEventListener("keydown", onKey);
}, { immediate: true });

onBeforeUnmount(() => window.removeEventListener("keydown", onKey));
</script>

<template>
  <Teleport to="body">
    <div v-if="open" class="ro-overlay confirm-overlay" role="presentation" @click.self="emit('cancel')">
      <section class="ro-modal confirm-dialog" role="dialog" aria-modal="true" :aria-label="title">
        <header class="ro-modal__header">
          <strong>{{ title }}</strong>
          <Button class="ro-modal__close" variant="ghost" icon="x" type="button" aria-label="关闭" @click="emit('cancel')" />
        </header>
        <div class="ro-modal__body"><p>{{ message }}</p></div>
        <footer class="ro-modal__footer">
          <Button type="button" @click="emit('cancel')">取消</Button>
          <Button type="button" variant="danger" @click="emit('confirm')">{{ confirmLabel }}</Button>
        </footer>
      </section>
    </div>
  </Teleport>
</template>

<style scoped>
.confirm-overlay { z-index: 80; }
.confirm-dialog { width: min(420px, 93vw); }
.confirm-dialog p { margin: 0; }
</style>
